// extracted by mini-css-extract-plugin
export default {"sliderItem":"SportsListingCard_sliderItem__PvKqO","imageBlock":"SportsListingCard_imageBlock__DTdQ1","sportsInfo":"SportsListingCard_sportsInfo__SL5uj"};